// SPDX-License-Identifier: AGPL-3.0-or-later

import {makePersistent} from '@app/features/platform/utils/MobXPersistence';
import {makeAutoObservable} from 'mobx';

/**
 * Unsent WhatsApp composer text per chat, kept across leaving the chat and reloads.
 * Local to this device, like Konvo channel drafts (MessagingDrafts).
 */
class WhatsAppDrafts {
	drafts: Record<string, string> = {};

	constructor() {
		makeAutoObservable(this, {}, {autoBind: true});
		void makePersistent(this, 'WhatsAppDrafts', ['drafts'], {writeDelayMs: 400});
	}

	get(jid: string): string {
		return this.drafts[jid] ?? '';
	}

	/** The composer's text exactly as typed, so a leading space or newline survives the round trip. */
	set(jid: string, text: string): void {
		if (!text) this.clear(jid);
		else if (this.drafts[jid] !== text) this.drafts[jid] = text;
	}

	/** One line for a chat row; whitespace alone is no draft. */
	preview(jid: string): string {
		return this.get(jid).replace(/\s+/g, ' ').trim();
	}

	clear(jid: string): void {
		if (jid in this.drafts) delete this.drafts[jid];
	}
}

export default new WhatsAppDrafts();
